import React from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';

import * as animation from './animation';

const MI = (props) => {
  return (
    <Lottie
      options={{
        autoplay: false,
        loop: false,
        animationData: animation,
        rendererSettings: {
          filterSize: {
            width: '300%',
            height: '300%',
            x: '-100%',
            y: '-100%',
          },
        },
      }}
      {...props}
    />
  );
};

MI.propTypes = {
  props: PropTypes.object,
};

export default MI;
